import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { useDropOffLocationContext } from '../../core/application/contexts'
import { MobileDrawerPanel } from '../../core/application/types'
import { FilterIcon, MagnifyingGlassIcon, PlusIcon } from '../icons'
import DownChevronIcon from '../icons/DownChevronIcon'
import PanelContainer from './PanelContainer'
import { WasteType } from '../../core/domain/models'

export interface ISelectorPanelProps {
  onClick: (panel: MobileDrawerPanel) => void
  wasteTypeList: WasteType[]
}

const SelectorPanel: React.FC<ISelectorPanelProps> = ({ onClick, wasteTypeList }) => {
  const { wasteTypeFilters } = useDropOffLocationContext()
  const filterLabel = useMemo(() => {
    if (wasteTypeFilters.length) {
      const wasteTypeLabels = wasteTypeList.filter((wasteType) => wasteTypeFilters.includes(wasteType.id))
      return wasteTypeLabels.map(it => it.name).slice(0, 3).join(', ')
    }
    return <FormattedMessage id="SelectorPanel.ActionButton.Sort" />
  }, [wasteTypeFilters, wasteTypeList])

  return (
    <Container>
      <ActionButton onClick={() => onClick(MobileDrawerPanel.SEARCH_PANEL)}>
        <div>
          <MagnifyingGlassIcon />
          <FormattedMessage id="SelectorPanel.ActionButton.Find" />
        </div>
        <div>
          <DownChevronIcon />
        </div>
      </ActionButton>
      <ActionButton onClick={() => onClick(MobileDrawerPanel.SORT_PANEL)}>
        <div>
          <FilterIconWrapper>
            <FilterIcon />
          </FilterIconWrapper>

          <FilterLabel>{filterLabel}</FilterLabel>
        </div>
        <div>
          <DownChevronIcon />
        </div>
      </ActionButton>
      <ActionButton onClick={() => onClick(MobileDrawerPanel.SUBMIT_PANEL)}>
        <div>
          <PlusIcon />
          <FormattedMessage id="SelectorPanel.ActionButton.Submit" />
        </div>
        <div>
          <DownChevronIcon />
        </div>
      </ActionButton>
    </Container>
  )
}

const Container = styled(PanelContainer)`
  row-gap: 12px;
  overflow: hidden;
`

const ActionButton = styled.button`
  display: flex;
  flex-direction: row;
  background-color: #f2f2f2;
  padding: 12px;
  align-items: center;
  border-radius: 4px;

  :disabled {
    opacity: 0.3;
  }

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    overflow: hidden;
  }

  & > div:first-child {
    column-gap: 8px;
    color: ${({ theme }) => theme.color.black};
  }

  & > div:last-child {
    min-width: fit-content;
    flex-basis: auto;
    justify-content: flex-end;
  }

  & > div:last-child svg {
    transform: rotate(-90deg);
  }
`

const FilterIconWrapper = styled.div`
  max-width: fit-content;
  flex-basis: auto;
`

const FilterLabel = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  text-align: left;
`

export default SelectorPanel
